/**
 * This is the self-initializing version for CDNs.
 * It will be compiled as index.umd.js
 */
import ThumbHashElement from "./ThumbHashElement.js";
ThumbHashElement.init();
